import { render, staticRenderFns } from "./image-with-text-conven-feet-02.vue?vue&type=template&id=1672639f&scoped=true&"
import script from "./image-with-text-conven-feet-02.vue?vue&type=script&lang=js&"
export * from "./image-with-text-conven-feet-02.vue?vue&type=script&lang=js&"
import style0 from "./image-with-text-conven-feet-02.vue?vue&type=style&index=0&id=1672639f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1672639f",
  null
  
)

export default component.exports